/** Parse Axion SRRI value into integer 1–7, or null if missing/invalid. Pure — no client import. */
export function parseSquadSrriLevel(raw: unknown): number | null {
  if (raw == null || raw === '') return null;
  const match = String(raw).trim().match(/([1-7])/);
  if (!match) return null;
  const n = Number(match[1]);
  return Number.isFinite(n) && n >= 1 && n <= 7 ? n : null;
}
